<template>
    
      <div class=" m-2 p-1 divide-gray-200 rounded-lg bg-white hover:bg-gray-100 shadow hover:shadow-xl" >

        <div class="flex w-full items-center justify-between space-x-6 pt-2 pl-2 pb-2 pr-4 md:p-6">
          <div class="flex-1 truncate">
            <!-- {{ index + 1 }} -->
              
            <div class="flex items-center space-x-3">

              

              <h3 class="truncate text-xlg font-medium text-primaryText">{{ doctor_object.cn_name }}医生</h3>
              <!-- <div>{{ doctor_object.en_firstname }} {{ doctor_object.en_lastname }}</div> -->
              <span class="inline-flex flex-shrink-0 items-center rounded-full bg-primaryBtnHoverLite/50 px-1.5 py-0.5 text-xs font-medium text-primaryColor ring-1 ring-inset ring-primaryColor/20">{{ doctor_object.cn_specialty_1 }}</span>
              <span v-if="doctor_object.cn_specialty_2 && doctor_object.cn_specialty_2 !== undefined" class="inline-flex flex-shrink-0 items-center rounded-full bg-green-50 px-1.5 py-0.5 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">{{doctor_object.cn_specialty_2}}</span>
              
            </div>
           
            

            <!-- <p class="mt-1 whitespace-normal text-right sm:text-left sm:truncate text-sm text-gray-500 "> {{ doctor_object.en_full_address }}</p> -->
            
            <span class="text-sm text-gray-500" v-if="doctor_object.en_full_address">{{ doctor_object.en_full_address }}</span>
            <!-- {{ doctor_object }} -->
            <!-- <div v-for="(location,index) in doctor_object.locations" :key="location.en_full_address">
              
                <p class="mt-1 truncate text-sm text-gray-500"> {{ location.en_full_address }}</p>

            </div> -->


            
            
          </div>
          <LazyClientOnly>
                <img class="inline-flex aspect-square h-16 md:h-20 flex-shrink-0 rounded-full bg-gray-300" :src="doctor_object.doctor_profile_image_url? doctor_object.doctor_profile_image_url:'https://s3.amazonaws.com/cms-media.haodrs.com/no_image_icon_md_be41a8f87f.png'" alt="" />
          </LazyClientOnly>
          
        </div>

        <div class="p-1 sm:p-2 md:pl-6">
          <span class="flex items-center space-x-2">
                  <!-- <HandThumbUpIcon class="h-5 w-5 text-green-500" aria-hidden="true" v-if="doctor_object.verified" /> -->
                  <span class="inline-flex flex-shrink-0 items-center rounded-full bg-green-300/50 px-1.5 py-0.5 text-xs font-medium text-green-600 ring-1 ring-inset ring-green/20" aria-hidden="true" v-if="doctor_object.verified"> 认证诊所 </span>
                  <span class="inline-flex flex-shrink-0 items-center rounded-full bg-primary-500/50 px-1.5 py-0.5 text-xs font-medium text-primary-600 ring-1 ring-inset ring-primary-500/20" aria-hidden="true" v-if="doctor_object.tier != 0">高级服务保障</span>
                  <!-- <TierStars :tier="doctor_object.tier" class="h-5 w-5" aria-hidden="true" v-if="doctor_object.tier" /> -->
          </span>
        </div>
        
        <div>
            
          <div class="-mt-px flex divide-x divide-gray-200">
            <div class="flex w-0 flex-1">
              <a :href="`/doctor/${doctor_object.cn_specialty_1}/${doctor_object.cn_name}医生/appointment`" class="relative -mr-px inline-flex w-0 flex-1 items-center justify-center gap-x-3 rounded-bl-lg border border-transparent py-4 text-sm font-semibold text-primaryText hover:text-primaryBtnHover hover:bg-primaryBtnHoverLite">
                <CalendarIcon class="h-5 w-5 text-primaryColor/70" aria-hidden="true" />
                {{ $t("doctor.listcard_online_appt") }}
              </a>
            </div>

            <!-- <div class="-ml-px flex w-0 flex-1">
              
              <a v-if="doctor_object.tier === 'tier3' || doctor_object.tier === 'tier4'" :href="`tel:${doctor_object.telephone}`" class="relative inline-flex w-0 flex-1 items-center justify-center gap-x-3 border border-transparent py-4 text-sm font-semibold text-primaryText hover:text-primaryBtnHover hover:bg-primaryBtnHoverLite">
                <PhoneIcon class="h-5 w-5 text-primaryColor/70" aria-hidden="true" />
                VIP 客服
              </a>
              <a :href="`tel:${doctor_object.telephone_tracking_hys_1 ? doctor_object.telephone_tracking_hys_1 : doctor_object.telephone}`" class="relative inline-flex w-0 flex-1 items-center justify-center gap-x-3 border border-transparent py-4 text-sm font-semibold text-primaryText hover:text-primaryBtnHover hover:bg-primaryBtnHoverLite">
                <PhoneIcon class="h-5 w-5 text-primaryColor/70" aria-hidden="true" />
                {{ $t("doctor.listcard_call_clinic") }}
              </a>
            </div> -->
            <div class="-ml-px flex w-0 flex-1">
              <NuxtLink :to="`/doctor/${doctor_object.cn_specialty_1}/${doctor_object.cn_name}医生/`" class="relative inline-flex w-0 flex-1 items-center justify-center gap-x-3 rounded-br-lg  py-4 text-sm font-semibold bg-primaryBtnHoverLite/30 text-primaryText hover:text-primaryBtnHover hover:bg-primaryBtnHoverLite">
                <RectangleGroupIcon class="h-5 w-5 text-primaryColor/70" aria-hidden="true" />
                {{ $t("doctor.listcard_more_info") }}
              </NuxtLink>
            </div>
          </div>
        </div>
      </div>

  </template>
  
  <script setup>
  import { RectangleGroupIcon, CalendarIcon, PhoneIcon, HandThumbUpIcon } from '@heroicons/vue/20/solid'
  
  const stringToSlug = (Text) => {
    return Text
      .toLowerCase()
      .replace(/[^\w ]+/g, '')
      .replace(/ +/g, '-')
  }

  const props = defineProps({
    doctor_object: {
        type: Object,
        required: true
    },
    index: {
        type: Number,
        required: true
    }
})

  const people = [
    {
      name: 'Jane Cooper',
      title: 'Regional Paradigm Technician',
      role: 'Admin',
      email: 'janecooper@example.com',
      telephone: '+1-202-555-0170',
      imageUrl:
        'https://s3.amazonaws.com/cms-media.haodrs.com/no_image_icon_md_be41a8f87f.png',
    },
  
  ]
  </script>